import { gql } from "@apollo/client";export default gql`query bookAggregate {
    bookAggregate: group_aggregate(where: {type: {_eq: "book"}}) {
        aggregate {
            count
        }
    }
}
`;
